/**
 * Reusable stateless form component for Node
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import classNames from 'classnames';

// import form components
import {
  CheckboxInput
  , NumberInput
  , ObjectListComparator
  , SelectFromArray
  , SelectFromObject
  , TextAreaInput
  , TextInput
} from '../../../global/components/forms';
import MetricSelector from '../../metric/components/MetricSelector.js.jsx';

function NodeForm({
  handleFormChange
  , handleFormSubmit
  , node
  , allMetrics
  // , trackingMetrics
}) {

  return (
    <div className="form-container">
      <form name="nodeForm" className="node-form">
        <div className="-form-step"><span className="-num">1</span> General info</div>
        <TextAreaInput
          change={handleFormChange}
          label="Authoring Code"
          name="authoring.code"
          placeholder="Authoring Code"
          required={false}
          value={node.authoring.code}
        />
        <div className="yt-col full _40">
          <NumberInput
            change={handleFormChange}
            firefoxDisplayFix={true}
            helpText={"Follow ups are sorted low-to-high"}
            label="Order weight"
            name="orderWeight"
            required={false}
            value={node.orderWeight}
            />
        </div>
        <hr/>
        <CheckboxInput
          change={handleFormChange}
          checked={node.toc}
          label="Table of Contents node?"
          name="toc"
          value={node.toc}
          tooltipText={"If checked, this Node will show up in the Table of Contents for this Module"}
        />
        <CheckboxInput
          change={handleFormChange}
          checked={node.question}
          label="Question node?"
          name="question"
          value={node.question}
          tooltipText={"If checked, this Node will show up in the graph as a Question (for display purposes)"}
        />
        <CheckboxInput
          change={handleFormChange}
          checked={node.answer}
          label="Answer node?"
          name="answer"
          value={node.answer}
          tooltipText={"For tracking and display purposes"}
        />
        { node.answer ?
          <SelectFromArray
            capitalize={false}
            change={handleFormChange}
            items={['n/a','correct','incorrect', 'survey']}
            name='correct'
            value={node.correct}
          />
          : null
        }
        <CheckboxInput
          change={handleFormChange}
          checked={node.checkpoint}
          label="Checkpoint node?"
          name="checkpoint"
          value={node.checkpoint}
          tooltipText={"If checked, this Node, along with all other Checkpoint Nodes, will be used to calculate a users progress in the Module"}
        />
        <CheckboxInput
          change={handleFormChange}
          checked={node.topicChange}
          label="Topic change node?"
          name="topicChange"
          value={node.topicChange}
          tooltipText={"Used for displaying the node graph only"}
        />
        <CheckboxInput
          change={handleFormChange}
          checked={node.exit}
          label="Exit node?"
          name="exit"
          value={node.exit}
          tooltipText={"If checked, this Node will allow the User to finish the Module"}
        />
        <div className="-form-step">
          <span className="-num">2</span> Tracking metrics
          <button className="yt-btn x-small link u-pullRight" type="button" onClick={handleFormSubmit}>Save & Close</button>
        </div>
        <MetricSelector
          selectedMetrics={node._metrics || []}
          change={handleFormChange}
          name="_metrics"
        />
        {/* <ObjectListComparator
          addRemoveAll={true}
          addLabel="Add All"
          availableLabel="All Metrics"
          displayKey="title"
          name="_metrics"
          label={"Assign Tracking Metrics"}
          removeLabel="Remove All"
          selected={node._metrics || []}
          selectedLabel="Assigned Metrics"
          change={handleFormChange}
          items={allMetrics}
          valueKey="_id"
        /> */}
        {/* <TextAreaInput
          change={handleFormChange}
          label="Tracking Metric"
          name="metric"
          required={false}
          rows={'3'}
          value={node.metric}
          helpText={<h3 style={{color:'red'}}><em><strong>NOTE:</strong> ^ this should be replaced with one of the select dropdowns below. <br/> I'm just leaving this here for now so nothing breaks. -- erik</em></h3>}
        /> */}
        {/* <SelectFromArray
          capitalize={false}
          change={handleFormChange}
          filterable={true}
          items={trackingMetrics}
          label="Tracking Metric"
          name='metric'
          value={node.metric}
        /> */}
        <div className="-form-step"><span className="-num">3</span> Admin notes</div>
        <TextAreaInput
          change={handleFormChange}
          label="Admin Notes"
          name="notes"
          required={false}
          rows={'3'}
          value={node.notes}
        />

      </form>
    </div>
  )
}

NodeForm.propTypes = {
  handleFormChange: PropTypes.func.isRequired
  , node: PropTypes.object
  , allMetrics: PropTypes.array
  // , trackingMetrics: PropTypes.array
}

NodeForm.defaultProps = {
  formTitle: ''
  , allMetrics: []
}

export default NodeForm;



// WEBPACK FOOTER //
// modules/node/components/NodeForm.js.jsx